// ─── Task Contract Parser (v96) ───────────────────────────────────────────────
// Deterministic parser — extracts structured contract from free-text task input.
// Returns: { intent, contentType, dates[], entities[], raw }
// Dates have HIGHEST priority and are immutable throughout the pipeline.

const MONTHS_IT = 'gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre';

const TASK_INTENT_KEYWORDS = {
  promuovere:'promozione', promuovi:'promozione', promozione:'promozione',
  lanciare:'lancio', lancio:'lancio', lancia:'lancio',
  annunciare:'annuncio', annuncio:'annuncio', annuncia:'annuncio',
  raccontare:'racconto', racconta:'racconto',
  educare:'educazione', educa:'educazione', spiegare:'educazione', spiega:'educazione',
  vendere:'vendita', vendi:'vendita',
  invitare:'invito', invita:'invito',
  presentare:'presentazione', presenta:'presentazione',
  riassumere:'riassunto', riassumi:'riassunto',
  recensire:'recensione', analizzare:'analisi', confrontare:'confronto',
};

const TASK_CONTENT_TYPES = [
  'webinar','evento','workshop','corso','conferenza','meetup','summit',
  'prodotto','servizio','offerta','promozione','lancio',
  'articolo','report','case study','whitepaper','ebook','guida',
  'partnership','collaborazione','acquisizione','risultato','milestone',
  'aggiornamento','novità','news','comunicato',
];

const MONTH_NAMES = ['','gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];

export function parseTaskContract(taskText) {
  if (!taskText || typeof taskText !== 'string' || taskText.trim().length < 3) return null;

  const text  = taskText.trim();
  const lower = text.toLowerCase();
  const contract = { raw: text, intent: null, contentType: null, dates: [], entities: [] };

  // Intent
  for (const [kw, intent] of Object.entries(TASK_INTENT_KEYWORDS)) {
    if (lower.includes(kw)) { contract.intent = intent; break; }
  }

  // Content type
  for (const ct of TASK_CONTENT_TYPES) {
    if (lower.includes(ct)) { contract.contentType = ct; break; }
  }

  // Italian text dates: "29 febbraio 2026"
  const textDateRx = new RegExp(`\\b(\\d{1,2})\\s+(${MONTHS_IT})\\s+(20\\d{2})\\b`, 'gi');
  let m;
  while ((m = textDateRx.exec(text)) !== null) {
    contract.dates.push({
      value: m[0],
      normalized: `${m[1]} ${m[2].charAt(0).toUpperCase() + m[2].slice(1).toLowerCase()} ${m[3]}`,
      role: 'data_evento',
    });
  }

  // Numeric dates full: "29/02/2026"
  // eslint-disable-next-line no-useless-escape
  const numFullRx = /\b(\d{1,2})[/\-](\d{1,2})[/\-](20\d{2})\b/g;
  while ((m = numFullRx.exec(text)) !== null) {
    const day = parseInt(m[1], 10), month = parseInt(m[2], 10), year = m[3];
    if (month >= 1 && month <= 12) {
      const normalized = `${day} ${MONTH_NAMES[month].charAt(0).toUpperCase() + MONTH_NAMES[month].slice(1)} ${year}`;
      if (!contract.dates.some(d => d.normalized === normalized)) {
        contract.dates.push({ value: m[0], normalized, role: 'data_evento' });
      }
    }
  }

  // Numeric dates short: "29-02-26"
  // eslint-disable-next-line no-useless-escape
  const numShortRx = /\b(\d{1,2})[/\-](\d{1,2})[/\-](\d{2})\b/g;
  while ((m = numShortRx.exec(text)) !== null) {
    const day = parseInt(m[1], 10), month = parseInt(m[2], 10), year = `20${m[3]}`;
    if (month >= 1 && month <= 12) {
      const normalized = `${day} ${MONTH_NAMES[month].charAt(0).toUpperCase() + MONTH_NAMES[month].slice(1)} ${year}`;
      if (!contract.dates.some(d => d.normalized === normalized)) {
        contract.dates.push({ value: m[0], normalized, role: 'data_evento' });
      }
    }
  }

  return contract;
}
